import { render, staticRenderFns } from "./MyTag.vue?vue&type=template&id=41ae054a&scoped=true"
import script from "./MyTag.vue?vue&type=script&lang=js"
export * from "./MyTag.vue?vue&type=script&lang=js"
import style0 from "./MyTag.vue?vue&type=style&index=0&id=41ae054a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ae054a",
  null
  
)

export default component.exports